import { getApiConfig } from "../authHelper"

import { get, post, put, del } from "../api_helper"
import * as url from "../url_helper"

export const getAllUser = (queryData) => {
  const { page, limit, search, expirationType } = queryData
  return get(`${url.USER}?sortOrder=-1${search && `&search=${search}`}${expirationType && `&expirationType=${expirationType}`}${page && limit && `&page=${page}&limit=${limit}`}`, getApiConfig())
}


export const getAllUserSearch = (queryData) => {

  return get(`${url.USER}/all`, getApiConfig())

}

export const updateUser = (id, data) => {
  return put(`${url.USER}/${id}`, data, getApiConfig())
}

export const createUser = data => {
  return post(`${url.USER}/signup`, data, getApiConfig())
}

export const extendTrialByAdmin = (userId, days) => {
  return put(`${url.USER}/admin/extend-trial/${userId}`, { days }, getApiConfig())
}

export const getReferralDetails = userId => {
  return get(`${url.USER}/admin/referral-details/${userId}`, getApiConfig())
}
